function validateDuration(caseConf) {
  const errors = [];
  if (caseConf.timer) {
    const hours = parseInt(caseConf.timer.hours) || 0;
    const minutes = parseInt(caseConf.timer.minutes) || 0;
    const seconds = parseInt(caseConf.timer.seconds) || 0;
    if (!hours && !minutes && !seconds) {
      errors.push({ message: 'Case timer must be greater than 0 seconds.', category: 'scenario', field: 'timer' });
    }
  }
  return {
    errors,
    warnings: [],
  };
}

export default validateDuration;
